import { maLookback } from '../../math/ma'
import { COLOR, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

// Replaces the klinecharts DMA (difference of MAs), which stays as hidden DMA v1.
const def: IndicatorDef = {
  id: 'APO',
  version: 1,
  label: 'Absolute Price Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 70,
  inputs: [period('fastperiod', 12, 'Fast length'), period('slowperiod', 26, 'Slow length'), matype()],
  outputs: [line('apo', 'APO', COLOR.blue)],
  talib: { functions: ['APO'], expr: 'APO(close, fastperiod={fastperiod}, slowperiod={slowperiod}, matype={matype})' },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, slowperiod, matype }) => maLookback(Math.max(fastperiod, slowperiod), matype),
}
export default def
